import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Truck, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const USPStrip = () => {
  const { t } = useLanguage();

  const usps = [
    { icon: Flame, text: t('usp.fresh'), color: 'text-hanse-red' },
    { icon: Truck, text: t('usp.delivery'), color: 'text-hanse-gold' },
    { icon: Shield, text: t('usp.halal'), color: 'text-green-500' },
  ];

  return (
    <section className="bg-hanse-navy py-6" data-testid="usp-strip">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-16">
          {usps.map((usp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center gap-3"
              data-testid={`usp-item-${index}`}
            >
              <usp.icon className={`w-6 h-6 ${usp.color}`} />
              <span className="text-white font-semibold text-sm md:text-base">
                {usp.text}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USPStrip;
